<template>
    <div>
        <div class="page-promotions">
            <div class="page-promotions__title">
                <i class="icon-promotions"></i>
                <h1>{{ $t('front.promotion.page.title') }}</h1>
            </div>
            <div class="page-promotions__filter">
                <ul v-if="promotionCategories && (promotionCategories.length > 1)">
                    <li :class="{active: !selectedPromotionCategory}" @click="selectedPromotionCategory = null"
                        v-if="showAllCategoriesButton">
                        {{ $t('front.promotion.filter.all_promotions') }}
                    </li>
                    <li :class="{active: isCategoryActive(category)}" @click="selectedPromotionCategory = category"
                        v-for="category in promotionCategories" :key="category.id">{{ category.title }}
                    </li>
                </ul>
            </div>
            <div class="page-promotions__list">
                <div class="item" v-for="(item, index) in categoryPromotions" :key="index">
                    <div class="item__content"
                         :style="{background: item.color,'background-image': `url(${item[isDeviceMobile ? 'mobileImage' : 'desktopImage'][isWebpSupported ? 'webp' : 'jpg']})`}">
                        <h2 v-text="item.title"/>
                        <p v-text="item.description"/>
                        <v-btn class="link" @click="showPromotion(item.slug, index)">
                            {{ $t('front.promotion.button.read_more') }}
                        </v-btn>
                        <div class="txt">
                            {{ $t('front.promotion.titles.terms_and_conditions') }}
                        </div>
                    </div>
                </div>
            </div>

            <v-dialog content-class="v-dialog-promotion" v-model="$store.state.dialogs.promotion" max-width="780px"
                      :persistent="isDialogPersistent" v-if="$store.state.dialogs.promotion">
                <promotions-popups @close="closeDialog"
                                   :item="dialogItem"
                                   :index="promoIndex"
                                   :creative="promoCreative"
                                   :position="promoPosition"/>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import DialogSettings from "../../../../../../../src/mixins/dialogSettings";
import {promotionsFilter} from "../../../../../../../config/promotion";
import {fetchSinglePromotion} from "../../../../../../../src/api";
import apiData from "../../../../../../../src/mixins/apiData";
import {dialogsHashRoutes} from "../../../../../../../config/url";
import eventsInterface from "../../../../../../../src/interfaces/eventsInterface";

export default {
    name: "PromotionsItems",

    mixins: [DialogSettings, apiData],

    data() {
        return {
            dialog: false,
            dialogItem: {},
            promoIndex: undefined,
            promoCreative: 'Promotions',
            promoPosition: 'Page',
            selectedPromotionCategory: undefined,
            showAllCategoriesButton: promotionsFilter.showAllCategoriesButton,
        }
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData()
            .then(() => {
                if (!this.showAllCategoriesButton && this.promotionCategories.length > 1) {
                    this.selectedPromotionCategory = this.promotionCategories[0];
                } else {
                    this.selectedPromotionCategory = null;
                }
            });
    },

    beforeDestroy() {
        this.closeDialog();
    },

    watch: {
        '$route.hash': {
            handler: function (hash) {
                hash && !dialogsHashRoutes.includes(hash) &&  this.showPromotion(hash.slice(1));
            },
            deep: true,
            immediate: true
        },

        promotionDialog(isOpen) {
            if (!isOpen && this.$route.hash) {
                this.removeHashFromRoute();
            }
        },

        categoryPromotions(categoryPromotions) {
            void require('../../../../../../../src/util/analytics/index').trackEvent(eventsInterface.showPromotions, this, {
                promotions: categoryPromotions,
                creative: this.promoCreative,
                position: this.promoPosition,
                user: this.user,
            });
        },

        user(user, oldUser){
            if (user && !oldUser || !user && oldUser){
                this.fetchData(true);
            }
        },
    },

    computed: {
        isDeviceMobile() {
            return this.$store.state.isDeviceMobile;
        },

        isWebpSupported() {
            return this.$store.state.isWebpSupported;
        },

        promotionDialog() {
            return this.$store.state.dialogs.promotion;
        },

        locale() {
            return this.$store.state.locale;
        },

        user() {
            return this.$store.state.user;
        },

        currency() {
            return this.user && this.user.currency || this.$store.state.guestCurrency;
        },

        country() {
            return this.user && this.user.country || this.$store.state.guestCountry;
        },

        promotionCategories() {
            return this.$store.state.promotionsData && this.$store.state.promotionsData.categories;
        },

        promotions() {
            return this.$store.state.promotionsData && this.$store.state.promotionsData.promotions;
        },

        categoryPromotions() {
            if (this.selectedPromotionCategory) {
                return this.promotions.filter(promotion => promotion.promotionCategoryId === this.selectedPromotionCategory.id);
            } else {
                return this.promotions;
            }
        },
    },

    methods: {
        fetchData(mustReload = false) {
            return Promise.all([
                this.$store.dispatch('FETCH_PROMOTIONS_DATA', this.createApiData({
                    currency: this.currency,
                    country: this.country,
                    mustReload: mustReload,
                })),
            ]);
        },

        showPromotion(slug, index) {
            fetchSinglePromotion(this.createApiData({
                slug: slug,
            }))
                .then(promotion => {
                    if (promotion) {
                        this.dialogItem = promotion;
                        this.promoIndex = index;
                        this.$store.commit('OPEN_PROMOTION_DIALOG');
                    }
                })
                .catch();
        },

        isCategoryActive(category) {
            return this.selectedPromotionCategory && this.selectedPromotionCategory.id === category.id
        },

        closeDialog() {
            this.$store.commit('CLOSE_PROMOTION_DIALOG');
        },

        removeHashFromRoute() {
            let redirectRoute = this.$router.resolve({hash: ''});
            this.$router.replace(decodeURIComponent(redirectRoute.resolved.fullPath));
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/target/PromotionsItems"
</style>